<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div class="col-md-6">
        <label for="user_firstname" class="form-control-label">
          Nombre<span class="required">*</span>
        </label>
        <input
            id="user_firstname"
            v-model="formModel.firstname"
            :class="[
                        'form-control',
                        v.firstname.$error ? 'is-invalid' : '',
                      ]"
            type="text"
            placeholder=""
        />
        <p v-if="v.firstname.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.firstname.$errors[0].$message }}
          </small>
        </p>
      </div>
      <div class="col-md-6">
        <label for="user_lastname" class="form-control-label">
          Apellidos<span class="required">*</span>
        </label>
        <input
            v-model="formModel.lastname"
            id="user_lastname"
            :class="[
                        'form-control',
                        v.lastname.$error ? 'is-invalid' : '',
                      ]"
            type="text"
            placeholder=""
        />
        <p v-if="v.lastname.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.lastname.$errors[0].$message }}
          </small>
        </p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="user_email" class="form-control-label">
          Email<span class="required">*</span>
        </label>
        <input
            id="user_email"
            v-model="formModel.email"
            :class="[
                        'form-control',
                        v.email.$error ? 'is-invalid' : '',
                      ]"
            type="email"
            placeholder=""
        />
        <p v-if="v.email.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.email.$errors[0].$message }}
          </small>
        </p>
        <label for="user_active" class="form-control-label w-100">
          Perfil<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.profile"
            size="large"
            class="w-100"
        >
          <el-option value="Administrador" label="Administrador"/>
          <el-option value="Gestor" label="Gestor de contenidos" />
        </el-select>
      </div>
      <div class="col-md-6">
        <div v-if="action=== 'create'">
          <label for="user_password" class="form-control-label">
            Contraseña<span class="required">*</span>
          </label>
          <input
              v-model="formModel.newPassword"
              id="user_password"
              :class="[
                        'form-control',
                        v.newPassword.$error ? 'is-invalid' : '',
                      ]"
              type="password"
              placeholder="Entre una contraseña"
          />
          <p v-if="v.newPassword.$error" class="invalid-feedback mb-0">
            <small>
              {{ v.newPassword.$errors[0].$message }}
            </small>
          </p>
          <label for="user_password" class="form-control-label">
            Repetir Contraseña<span class="required">*</span>
          </label>
          <input
              v-model="formModel.newRetypedPassword"
              id="user_password"
              :class="['form-control', repeatPasswordError ? 'is-invalid' : '']"
              type="password"
              placeholder="Repita la Contraseña"
          />
          <p v-if="repeatPasswordError" class="invalid-feedback mb-0">
            <small>
              <span v-if="repeatPasswordError"> {{ repeatPasswordError }}</span>
            </small>
          </p>
        </div>

        <label for="user_active" class="form-control-label w-100">
          Activo
        </label>
        <el-select
            v-model="formModel.active"
            size="large"
            class="w-100"
        >
          <el-option :value="true" label="Si" />
          <el-option :value="false" label="No" />
        </el-select>
      </div>
    </div>
    <div class="mt-3">
      <button
          type="submit"
          class="
                      float-end
                      btn btn-primary
                      text-white
                      bg-blue-600
                      border border-primary
                      rounded-lg
                      hover:bg-blue-900
                    "
      >
        {{ buttonText }}
      </button>
      <button
          class="
                      me-2
                      float-end
                      btn btn-primary
                      text-danger
                      bg-white
                      border border-danger
                      rounded-lg
                      hover:bg-blue-900
                    "
          @click="handleCancel"
      >
        Cancelar
      </button>
    </div>
  </form>

</template>

<script setup>
import { ref, computed, defineProps } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useVuelidate from "@vuelidate/core";
import {required, helpers, email, minLength} from "@vuelidate/validators";
import Swal from "sweetalert2";

const store = useStore();
const router = useRouter();

const props = defineProps({
  entity: {
    type: Object,
    required: false
  },
  action: {
    type: String,
    required: true
  }
})
const buttonText = computed(() => props.action === 'create' ? 'Crear' : 'Guardar cambios');

const repeatPasswordError = ref()
const formModel = ref(props.entity|| {});
const rules = computed(() => {
  let data =  {
    firstname: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    lastname: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    email: {
      required: helpers.withMessage("Este campo es obligatorio", required),
      email: helpers.withMessage("Debe ser una dirección de email válida", email),
    },
    profile: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    active: {}
  };
  if(props.action === 'create'){
    data.newPassword =  {
      minLength: helpers.withMessage("Debe tener al menos 6 caractéres", minLength(6)),
      required:  helpers.withMessage("Este campo es obligatorio", required),
    }
  }
  return data
});

const v$ = useVuelidate(rules, formModel);
const v = v$.value;
v.locale = 'es'
const handleSubmit = () => {
  v$.value.$validate();

  if (!v$.value.$invalid) {
    repeatPasswordError.value = null
    if(props.action === 'create'){
      if(formModel.value.newPassword !== formModel.value.newRetypedPassword ){
        repeatPasswordError.value = 'Las contraseñas no coinciden'
      }else{
        createEntity(formModel.value);
      }
    }else{
      updateEntity(formModel.value);
    }
  }
};
const handleCancel = () => {
  router.push({ name: "Usuarios", params: {} });
};

const createEntity = async (user) => {
  await store.dispatch("user/add", user).then(async (res) => {
    if (res.status === 200) {
      await Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Usuario creado satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
      await router.push({name: "Usuarios", params: {}});
    } else {
      await Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Se ha producido un error.',
        showConfirmButton: false,
        timer: 3000
      })
    }

  })
};

const updateEntity = async (user) => {

  await store.dispatch("user/edit", user).then(async (res) => {
    if (res.status === 200) {
      await Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Usuario editado satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
      await router.push({name: "Usuarios", params: {}});
    } else {
      await Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: res.response.data['hydra:description'],
        showConfirmButton: false,
        timer: 3000
      })
    }
  })

};


</script>
